import React, { useRef, useState, useEffect, useMemo } from 'react';
import RatioAudioPlayer from './../../components/DebateArena/RatioAudioPlayer/RatioAudioPlayer';
import styles from './AudioSequencePlayer.module.css';
import { HiPlay, HiUsers } from 'react-icons/hi2';

export default function AudioSequencePlayer({
  messages,
  groupedByThread = {},
  groupedByTeam = {}
}) {
  const [mode, setMode] = useState('all'); // all | thread | team
  const [filterKey, setFilterKey] = useState(null);
  const [tduration, settduration] = useState(0);
  const [totalduration, settotalduration] = useState(0);
  const [tprogress, setprogress] = useState(0);
  const [newseektime, setnewseektime] = useState(0);
  const [focusThreadId, setFocusThreadId] = useState(null);
  const playerRef = useRef();
  
  const selection = useMemo(() => {
    if (mode === 'all') {
		return [...messages].sort((a, b) => a.timestamp - b.timestamp);
	}
	
    if (mode === 'thread' && groupedByThread[filterKey]) {
		return groupedByThread[filterKey].sort((a, b) => a.timestamp - b.timestamp);
	}
	
    if (mode === 'team' && groupedByTeam[filterKey]) {
		return groupedByTeam[filterKey].sort((a, b) => a.timestamp - b.timestamp);
	}
    return [];
  }, [mode, filterKey, messages, groupedByThread, groupedByTeam]);

  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    var totalduration = 0;
	if (selection.length === 0) return;
	setCurrentIdx(0);

    if (mode === 'all') {
		totalduration = messages.reduce((duration, item) => {
			  return duration += item.duration;
		}, 0);
	}
	
    if (mode === 'thread' && groupedByThread[filterKey]) {
		totalduration = groupedByThread[filterKey].reduce((duration, item) => {
			  return duration += item.duration;
		}, 0);
	}
	
    if (mode === 'team' && groupedByTeam[filterKey]) {
		totalduration = groupedByTeam[filterKey].reduce((duration, item) => {
			  return duration += item.duration;
		}, 0);
	}
	
	settotalduration(totalduration);

  }, [selection]);

	useEffect(() => {
	  if (!playerRef.current || !selection[currentIdx]) return;
	  const message = selection[currentIdx];
	  playerRef.current.setSrc(message.audioUrl);

	  playerRef.current.onEnded(() => {
		if (currentIdx < selection.length - 1) setCurrentIdx(currentIdx + 1);
		const message = selection[currentIdx + 1];
		if(message != undefined) {
			var tt = tduration + message.duration
			settduration(tt);
		}
	  });
	}, [currentIdx, selection]);


  const onendhandler = (progress) => {
		var curindex  = currentIdx;
		if (currentIdx < selection.length - 1) { 
			setCurrentIdx(currentIdx + 1);
			const message = selection[curindex];
			if(message != undefined) {
				var tt = tduration + message.duration;
				settduration(tt);
				setprogress(progress);
			}
		} else {
			settduration(0);
			setprogress(0);
			setCurrentIdx(0);
			playerRef.current.pause();	
		}
  };
  
  const onloadhandler = () => {
	  if(currentIdx > 0) playerRef.current.play();
  };
  
  const onhandleseek = (e) => {
	var curidx = 0;
	var tt = 0;
	var newtime = 0;
	while(curidx < selection.length) {
		const message = selection[curidx];
		if(message != undefined) {
			//console.log((tt + message.duration) , e)
			if((tt + message.duration) > e) {
				setCurrentIdx(curidx);
				settduration(tt);
				newtime = e - tt;
				setnewseektime(newtime);
				setprogress((newtime / totalduration) * 100);
				//console.log(e, curidx, tt, newtime, ((newtime / totalduration) * 100))
				break;
			}
			tt = tt + message.duration;
		}

		curidx++;
	}
	return newtime;
  };
  
  const onhandledseek = (e) => {
	setnewseektime(0);
	if(currentIdx == 0) playerRef.current.play();
  };
  
  const OnClickerHandler = (e) => {
	//console.log(e)
	const [key, value] = e.split(":");
	if(key == 'all') {
		setMode('all');
	
	}
	else if (key == 'thread') {
		setMode('thread'); 
		setFilterKey(value);
	}
	else if (key == 'team') {
		setMode('team'); 
		setFilterKey(value);
	}
	setFocusThreadId(e);
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.controls}>
		<div className={styles.threadMap}>
		  {/*<label htmlFor="threadSelector">View Thread:</label>*/}
		  <select
			id="threadSelector"
			value={focusThreadId || ''}
			onChange={e => OnClickerHandler(e.target.value || null)}
			className={styles.threadSelect}>
			<option key={"all"} value={`all:all`}>
				Play All
			</option>
			{Object.keys(groupedByThread).map(threadId => (
			  <option key={threadId} value={`thread:${threadId}`}>
				Thread {threadId.slice(-5)}
			  </option>
			))}
			{Object.keys(groupedByTeam).map(teamName => (
			  <option key={teamName} value={`team:${teamName}`}>
				Team {teamName}
			  </option>
			))}
		  </select>
		</div>
      </div>
      {selection.length > 0 ? (
        <>
          <RatioAudioPlayer
		    ref={playerRef}
			audiodurationn={totalduration}
			newseektime={newseektime}
			culdurationn={tduration}
			tprogress={tprogress}
			src={selection[currentIdx]?.audioUrl}
            key={selection[currentIdx]?.id} OnLoaded={onloadhandler} onEnded={onendhandler} onSeek={onhandleseek} OnSeekHandled={onhandledseek}/>
          <div className={styles.playbackInfo}>
            Playing message: {selection[currentIdx]?.id.slice(-5)} ({currentIdx + 1}/{selection.length})
          </div>
        </>
      ) : (
        <div className={styles.empty}>No messages to play</div>
      )}
    </div>
  );
}
